module.exports = __webpack_public_path__ + "static/media/policlinica.ad1d0e82.png";